export default __webpack_public_path__ + "static/media/association-film-logo-branco.58824f56.png";